import { render, staticRenderFns } from "./removeCollaborator.vue?vue&type=template&id=58ef144c&scoped=true&"
import script from "./removeCollaborator.vue?vue&type=script&lang=js&"
export * from "./removeCollaborator.vue?vue&type=script&lang=js&"
import style0 from "./removeCollaborator.vue?vue&type=style&index=0&id=58ef144c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef144c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ef144c')) {
      api.createRecord('58ef144c', component.options)
    } else {
      api.reload('58ef144c', component.options)
    }
    module.hot.accept("./removeCollaborator.vue?vue&type=template&id=58ef144c&scoped=true&", function () {
      api.rerender('58ef144c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/collaborators/removeCollaborator.vue"
export default component.exports